import { BULK_UPLOAD_NOTES } from "../employeeFieldSchema";

export default function HowToUploadGuide() {
  const steps = [
    {
      title: "Upload & map file",
      body: "Upload CSV/XLSX with the same fields as Add Employee (personal, org, CTC, banking, statutory). Employee code is auto-generated — do not include it.",
    },
    {
      title: "Import preview",
      body: "Review rows parsed from your file. Nothing is created in the database yet.",
    },
    {
      title: "Complete requirements",
      body: "Mandatory for every employee: department, designation, location, role, and all other required fields.",
    },
    {
      title: "Review & create",
      body: "Final validation runs again. Employees are created with banking and statutory details when those columns are filled. Leave banking/statutory blank to skip — same as Skip on Add Employee.",
    },
  ];

  const mistakes = [
    {
      title: "Skipping requirements step",
      body: "You cannot create employees until every row is marked Complete on the requirements screen.",
    },
    {
      title: "Missing org fields",
      body: "Department, designation, and location must be selected for each employee — even if not in the file.",
    },
    {
      title: "Partial banking / invalid IFSC",
      body: "To skip banking, leave all banking columns empty. If any banking cell is filled, provide a real IFSC and account number (9–18 digits). Sample PAN/UAN/Aadhaar must match format rules.",
    },
  ];

  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-5">
      <h3 className="text-base font-bold text-slate-900">How to Upload</h3>
      <p className="text-sm text-slate-500 mt-1">
        Professional bulk flow: upload first → complete each employee → review → create.
      </p>

      <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3">
        {steps.map((s, i) => (
          <div key={s.title} className="p-4 rounded-xl border border-slate-200 bg-slate-50/40">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-lg bg-indigo-600 text-white text-xs font-bold flex items-center justify-center">
                {i + 1}
              </div>
              <p className="font-bold text-slate-900">{s.title}</p>
            </div>
            <p className="text-sm text-slate-600 mt-2">{s.body}</p>
          </div>
        ))}
      </div>

      <div className="mt-4 p-4 rounded-xl border border-indigo-200 bg-indigo-50/60">
        <p className="text-sm font-bold text-indigo-900">Important</p>
        <ul className="mt-2 space-y-1 text-sm text-indigo-900/90 list-disc list-inside">
          {BULK_UPLOAD_NOTES.map((note) => (
            <li key={note}>{note}</li>
          ))}
        </ul>
      </div>

      <div className="mt-5">
        <h4 className="text-sm font-bold text-slate-900">Common mistakes</h4>
        <div className="mt-2 grid grid-cols-1 md:grid-cols-3 gap-3">
          {mistakes.map((m) => (
            <div key={m.title} className="p-4 rounded-xl border border-amber-200 bg-amber-50">
              <p className="text-sm font-bold text-amber-900">{m.title}</p>
              <p className="text-sm text-amber-800 mt-1">{m.body}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
